/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyRateConfiguration {
    getFixupPrototypeFunction() { return CurrencyRateConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CurrencyRateConfiguration>): CurrencyRateConfiguration {
        let obj = Object.assign(new CurrencyRateConfiguration(), model);
        CurrencyRateConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyRateConfiguration>): CurrencyRateConfiguration {
        if (!model) return null;
        return CurrencyRateConfiguration.newInstance(<CurrencyRateConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyRateConfiguration) {
        if (!obj) return;

        models.CurrencyRateConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyRateConfiguration): boolean {
        Object.setPrototypeOf(obj, CurrencyRateConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.currency_rate) {
            for (let val of this.currency_rate) {
                models.ExchangeCurrencyRate.fixupPrototype(val);
            }
        }
    }

    /**
     * Currency Rate of Currency Exchange Configuration
     */
    currency_rate: Array<models.ExchangeCurrencyRate>;

    /**
     * Start date of the Currency Exchange Configuration
     */
    start_date: Date;

    /**
     * End date of the Currency Exchange Configuration
     */
    end_date: Date;

}
